import * as React from "react";
const SvgBlurOff = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 6,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.8 11.48.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 10,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 6,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 6,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 14,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 18,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7-7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-18 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 18,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 14,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 5.27 6 8.77l.28.28L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81A.875.875 0 0 0 14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78h.01l1.41-1.41L3.91 3.86 2.5 5.27z",
  fill: "currentColor"
}));
export default SvgBlurOff;